import { render, staticRenderFns } from "./centerOrderStatus.vue?vue&type=template&id=6194dd15&"
import script from "./centerOrderStatus.vue?vue&type=script&lang=js&"
export * from "./centerOrderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports